module.exports = __webpack_public_path__ + "img/bigflo-et-oli.4efa4267.jpg";